import React from 'react';
import './LoadingSpinner.css';

/**
 * 로딩 스피너 컴포넌트
 * @param {string} message - 로딩 메시지
 * @param {string} size - 스피너 크기 ('small', 'medium', 'large')
 */
const LoadingSpinner = ({ 
  message = '로딩 중...', 
  size = 'medium' 
}) => {
  return (
    <div className={`loading-container ${size}`}>
      <div className="spinner"></div>
      {message && <div className="loading-message">{message}</div>}
    </div>
  );
};

export default LoadingSpinner;